import { memo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

type Props = {
	isValid: boolean;
	isDirty: boolean;
	onUpdate: () => void;
};

export const SettingsPaymentDepositAccountHeader = memo(({ isValid, isDirty, onUpdate }: Props) => {
	const variant = isValid && isDirty ? "default" : "disabled";

	return (
		<FeatureIslandHeader
			title="入金先情報の設定"
			rightChildren={
				<Button variant={variant} size="xl" onClick={onUpdate}>
					保存
				</Button>
			}
		/>
	);
});
